import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Spacings } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import H5 from '@base/H5/H5';
import H7 from '@base/H7/H7';
import P2 from '@base/P2/P2';
import Image from '@base/Image';

const Wrapper = styled.div`
  background: var(--color-base-1);
  box-shadow: ${boxShadowGenerator()};
  border-radius: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_6B};
  padding-right: ${Spacings.SPACING_5B};
  pointer-events: auto;
  width: 320px;
`;

const StyH5 = styled(H5)`
  margin-top: ${Spacings.SPACING_2B};
  margin-bottom: ${Spacings.SPACING_1B};
`;

const LearnMoreWrapper = styled.div`
  display: inline-flex;
  cursor: pointer;
  margin-top: ${Spacings.SPACING_6B};
  padding-bottom: 7px;
  border-bottom: ${Spacings.SPACING_1} dashed var(--color-base-fill);
`;

const EmptyGroupCard = ({ onLearnWithGroup }) => {
  return (
    <Wrapper>
      <Image
        src="groups/empty-group.png"
        alt="unacademy"
        height={60}
        width={60}
      />
      <StyH5>Study with learners in your goal</StyH5>
      <P2 color="var(--color-text-secondary)">
        Group is the all-new way to learn with your friends and compete with
        them in weekly competitions.
      </P2>
      <LearnMoreWrapper onClick={onLearnWithGroup}>
        <H7>Learn more</H7>
      </LearnMoreWrapper>
    </Wrapper>
  );
};

export default EmptyGroupCard;

EmptyGroupCard.propTypes = {
  onLearnWithGroup: PropTypes.func.isRequired
};
